export default {
    name: "header-config-mixin",
    methods: {
        getTitleAndStepperConfig() {
            return {
                mainText: `Hypothetical: ${this.$store.getters["hypo/getName"]}`,
                menuOptions: this.getHeaderOptions()
            };
        }
    }
};
